import { newArticleTiles } from "@/data/supportArticles";

interface SearchableArticle {
  slug: string;
  title: string;
  description: string;
  category: string;
}

// 7 original articles hardcoded in Support.tsx
const ORIGINAL_ARTICLES: SearchableArticle[] = [
  { slug: "getting-started-with-mollie", title: "Getting Started with Mollie Payments", description: "Complete guide to setting up Mollie payment processing", category: "Payments" },
  { slug: "getting-started-with-pta-hub", title: "Getting Started with PTA Hub", description: "Learn the basics of setting up your PTA account", category: "Getting Started" },
  { slug: "managing-member-roles", title: "Managing Member Roles", description: "How to assign and manage member permissions", category: "Administration" },
  { slug: "creating-your-first-event", title: "Creating Your First Event", description: "Step-by-step guide to event planning", category: "Events" },
  { slug: "setting-up-fundraising-goals", title: "Setting Up Fundraising Goals", description: "Track and manage your fundraising objectives", category: "Fundraising" },
  { slug: "using-the-raffle-game", title: "Using the Raffle Game", description: "Complete guide to running digital raffles", category: "Games" },
  { slug: "financial-reporting-guide", title: "Financial Reporting Guide", description: "Generate and export financial reports", category: "Finance" },
];

const STOPWORDS = new Set([
  "the", "and", "for", "with", "from", "that", "this", "have", "has", "had",
  "are", "was", "were", "but", "not", "you", "your", "our", "can", "how",
  "why", "what", "when", "where", "who", "which", "into", "out", "off",
  "any", "all", "some", "one", "two", "ive", "i'm", "im", "ill", "i'll",
  "its", "it's", "doesn't", "doesnt", "don't", "dont", "won't", "wont",
  "cant", "can't", "isnt", "isn't", "got", "get", "getting", "use", "using",
  "want", "need", "help", "please", "issue", "problem", "thanks", "thank",
]);

function tokenise(text: string): string[] {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .split(/\s+/)
    .filter(t => t.length >= 3 && !STOPWORDS.has(t));
}

const CORPUS: SearchableArticle[] = [
  ...ORIGINAL_ARTICLES,
  ...newArticleTiles.map(t => ({
    slug: t.slug,
    title: t.title,
    description: t.description,
    category: t.category,
  })),
];

export interface ArticleSuggestion {
  slug: string;
  title: string;
  category: string;
  score: number;
}

export function getArticleSuggestions(query: string, limit = 3): ArticleSuggestion[] {
  const tokens = tokenise(query);
  if (tokens.length === 0) return [];

  const scored = CORPUS.map(a => {
    const title = a.title.toLowerCase();
    const desc = a.description.toLowerCase();
    const cat = a.category.toLowerCase();
    let score = 0;
    for (const t of tokens) {
      if (title.includes(t)) score += 2;
      if (desc.includes(t)) score += 1;
      if (cat.includes(t)) score += 1;
    }
    return { slug: a.slug, title: a.title, category: a.category, score };
  })
    .filter(a => a.score > 0)
    .sort((a, b) => b.score - a.score);

  return scored.slice(0, limit);
}
